import { render, staticRenderFns } from "./ChartSales.vue?vue&type=template&id=481378ea&scoped=true&"
import script from "./ChartSales.vue?vue&type=script&lang=js&"
export * from "./ChartSales.vue?vue&type=script&lang=js&"
import style0 from "./ChartSales.vue?vue&type=style&index=0&id=481378ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481378ea",
  null
  
)

export default component.exports